var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-radio-button-container",class:_vm.nativeValue == _vm.value ? 'checked' : '',on:{"click":_vm.handlerInput}},[_c('span',{staticClass:"g-radio-check"}),_c('input',{attrs:{"type":"radio","name":_vm.name,"id":_vm.id},domProps:{"value":_vm.nativeValue}}),_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }